<body>
  <a href="https://api.whatsapp.com/send?phone=41796108452" target="_blank" class="fixed-bottom"><i class="fab fa-whatsapp-square fa-5x"></i></a>
</body>
